<template>
	<!-- Base wrapper around v-select to ensure consistent defaults across the app. -->
	<v-select v-bind="$attrs" hide-details="auto" :chips="!!$attrs.multiple" :deletable-chips="!!$attrs.multiple" variant="outlined">
		<!-- Bold the trailing (Required)/(Optional) tag on the label (LSP-16777).
		     Label arrives via $attrs; render through FieldLabel unless a caller supplies its own #label. -->
		<template v-if="$attrs.label && !$slots.label" #label>
			<FieldLabel :label="String($attrs.label)" />
		</template>
		<template v-for="(_, slot) in $slots" #[slot]="scope" :key="slot">
			<slot :name="slot" v-bind="scope || {}"></slot>
		</template>
	</v-select>
	<!-- NOTE: We forward attrs/listeners so parent components can use v-model and events directly. -->
</template>

<script setup lang="ts">
	import FieldLabel from "@common-ui/components/FieldLabel.vue";
</script>
